import { createContext, useContext } from 'react'

export const WindowDimensionsContext = createContext()

export const useWindowDimensionsContext = () =>
  useContext(WindowDimensionsContext)
